import styled from 'styled-components';

const SentWrapperStyled = styled.div(({ theme }) => ({
  marginTop: theme.space[1],
  display: 'inline-flex',
  alignItems: 'center',
  fontSize: theme.font.size.xxsmall,
  color: theme.color.wfGrey600,
}));

const SentByStyled = styled.div(({ theme }) => ({
  color: theme.color.wfBlack,
}));

const SentAsStyled = styled.div(({ theme }) => ({
  color: theme.color.primary,
}));

export { SentWrapperStyled, SentByStyled, SentAsStyled };
